import React, {useState} from "react"
import {IconButton, Loader} from "rsuite"
import {Container} from "aurelia-framework"
import {UserClient} from "../../api/user-client"
import {useInterfaceImplementationsQuery} from "../../store/api";
import {useRealCostsAddAssignmentsMutation} from "../store/costs-api"
import {selectEntities} from "../../dialog/universal-entity-select"
import SioIcon from "../../icon/rsuite-icon-font/SioIcon"
import CostSourceCandidateButtons from "./cost-source-candidate-buttons"

const userClient = Container.instance.get(UserClient)

export default function LinkButtons({i18n, origin, creditor, data}) {
    const {isLoading, data: models} = useInterfaceImplementationsQuery("costs/real-costs-destination")
    const [doLink, {isFetching}] = useRealCostsAddAssignmentsMutation()
    const [pendingDestination, setPendingDestination] = useState(null)

    async function link(combinedId) {
        let field = "creditor"
        let conditions = undefined

        switch (combinedId) {
            case "order/order-item":
                field = "serviceProviders"
                conditions = !creditor?.id ? {} : {
                    $or: [
                        {[field]: {$exists: false}},
                        {[field]: {$eq: creditor}},
                        {ignoreServiceProvider: true},
                    ]
                }
                conditions.incomeSourceIdentifier = {$eq: null}
                break

            case "tourism/journey":
                field = "serviceProvider"
                conditions = {
                    marginReport: true,
                    marginReportDirty: true,
                }
                break

            case "costs/margin-report":
                conditions = {
                    reference: {$eq: null},
                    $or: [
                        {fixedDate: {$exists: false}},
                        {dirty: true},
                    ],
                }
                break

            case "inventory-management/stock-order-item":
                break;
        }

        if ("order/order-item" === combinedId) {
            // @todo setting
            if ('605c7575ca2ceb2a3e1a88b2' === userClient.getUser()?.organization?.id) {
                delete conditions.$or
            }

            const {wasCancelled, output} = await selectEntities("order/order", conditions)

            if (wasCancelled || !output.length) {
                return
            }

            const {id, modelId} = output[0]
            combinedId = "order/order-item"
            conditions = !creditor?.id ? undefined : {
                order: {$eq: {id, modelId}},
                $or: [
                    {serviceProviders: {$exists: false}},
                    {serviceProviders: {$eq: creditor}},
                    {ignoreServiceProvider: true},
                ]
            }
        }

        if ('inventory-management/stock-order-item' === combinedId) {
            // @todo setting
            if ('605c7575ca2ceb2a3e1a88b2' === userClient.getUser()?.organization?.id) {
                delete conditions.$or;
            }

            const { wasCancelled, output } = await selectEntities('inventory-management/stock-order', conditions);

            if (wasCancelled || !output.length) {
                return;
            }

            const { id, modelId } = output[0];
            combinedId = 'inventory-management/stock-order-item';
            conditions = {
                order: { $eq: { id, modelId } }
            };
        }

        // @todo setting
        if ('605c7575ca2ceb2a3e1a88b2' === userClient.getUser()?.organization?.id) {
            delete conditions.$or
        }

        if (!data?.settings?.journey?.assignCostsToReport && (combinedId === "tourism/journey" || combinedId === "costs/margin-report")) {
            const {wasCancelled, output} = await selectEntities(combinedId, conditions)

            if (wasCancelled || !output.length) {
                return
            }

            setPendingDestination(output[0])
            return
        }

        const {wasCancelled, output} = await selectEntities(combinedId, conditions)

        if (!wasCancelled && output.length) {
            doLink({origin, destinations: output.map(({id, modelId}) => ({id, modelId}))})
        }
    }

    if (pendingDestination) {
        return (
            <CostSourceCandidateButtons
                destination={pendingDestination}
                onSelect={(identifier) => {
                    doLink({origin, destinations: [{id: pendingDestination.id, modelId: pendingDestination.modelId}], targetCostSourceIdentifier: identifier})
                    setPendingDestination(null)
                }}
                onCancel={() => setPendingDestination(null)}
            />
        )
    }

    return isLoading ? (
        <Loader/>
    ) : models.map(({combinedId, label}) => (
        <IconButton
            size="sm"
            key={combinedId}
            style={{marginRight: "6px"}}
            loading={isFetching}
            icon={<SioIcon icon="fa fa-plus"/>}
            onClick={() => link(combinedId)}
        >
            {i18n.tr(label)}
        </IconButton>
    ))
}
